import styled from "styled-components";

import { ReactComponent as TrashIcon } from "assets/delete.svg";

type Props = {
  text: string;
  onClose: () => void;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  border-radius: 5px;
  background: var(--black-400);
  margin-right: 0.8rem;
  margin-top: 0.8rem;
  padding: 0.5rem 0.8rem;

  p {
    font-size: 0.9rem;
  }

  button {
    background-color: var(--black-300);
    padding: 0rem;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.4s;

    &:hover {
      background-color: var(--black-100);
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

function InfoTag({ text, onClose }: Props) {
  return (
    <Container>
      <p>{text}</p>

      <button type="button" onClick={() => onClose()}>
        <TrashIcon />
      </button>
    </Container>
  );
}

export { InfoTag };
